module.exports = __webpack_public_path__ + "static/technologyStack-55c85f38685bd23477ada486b3e73152.png";